import React, { useEffect, useRef, useState } from 'react'
import { connect as connectRedux } from 'react-redux'
import { List, Map } from 'immutable'
import { getBoundActions } from '../../actions/index'
import { getSeo } from '../../services/url/index'
import { getPrimary } from '../../services/languages/index'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import { SCREEN_TYPE_EVENTS_PLUS } from '../../services/upstream-context/index'
import { getPmScreenSectionSectionIds } from '../../services/pm-screen/index'
import { selectFaqs, selectSeries } from '../../services/node/index'

import GaiaPlusJumbotron from './GaiaPlusJumbotron'
import GaiaPlusCeoTalks from './GaiaPlusCeoTalks'
import GaiaPlusIntro from './GaiaPlusIntro'
import GaiaPlusIncluded from './GaiaPlusIncluded'
import GaiaPlusMembership from './GaiaPlusMembership'
import GaiaPlusJoin from './GaiaPlusJoin'
import GaiaPlusUpgrade from './GaiaPlusUpgrade'
import GaiaPlusFaq from './GaiaPlusFaq'

const FAQ_DISPLAY_MODE = 'faq'
const TILE_DISPLAY_MODE = 'tile-list-5x7'

function GaiaPlusPage ({
  auth,
  path,
  faqs,
  series,
  language,
  pmSection,
  sectionIds,
  staticText,
  setPageSeo,
  getLiveAccessEventList,
}) {
  const [faqSectionId, setFaqSectionId] = useState()
  const [introSectionId, setIntroSectionId] = useState()
  const upgradeSectionRef = useRef()

  const handleJoinButtonClick = () => {
    if (upgradeSectionRef.current) {
      requestAnimationFrame(() => upgradeSectionRef.current.scrollIntoView())
    }
  }

  useEffect(() => {
    setFaqSectionId(pmSection.findKey(
      (pm) => sectionIds.contains(pm.getIn(['data', 'id']))
      && pm.getIn(['data', 'data', 'displayMode']) === FAQ_DISPLAY_MODE,
    ))
    setIntroSectionId(pmSection.findKey(
      (pm) => sectionIds.contains(pm.getIn(['data', 'id']))
      && pm.getIn(['data', 'data', 'displayMode']) === TILE_DISPLAY_MODE,
    ))
  }, [pmSection, sectionIds])

  useEffect(() => {
    getLiveAccessEventList(language)
  }, [language])

  useEffect(() => {
    const seo = getSeo({
      pathname: path,
      loggedIn: getAuthIsLoggedIn(auth),
    })
    setPageSeo({
      ...seo,
      location: path,
    })
  }, [])

  return (
    <div className="gaia-plus-page">
      <GaiaPlusJumbotron staticText={staticText} onJoinButtonClick={handleJoinButtonClick} />
      <GaiaPlusCeoTalks staticText={staticText} onJoinButtonClick={handleJoinButtonClick} />
      <GaiaPlusIntro
        sectionId={introSectionId}
        pmSection={pmSection}
        series={series}
        language={language}
      />
      <GaiaPlusIncluded staticText={staticText} onJoinButtonClick={handleJoinButtonClick} />
      <GaiaPlusMembership staticText={staticText} onJoinButtonClick={handleJoinButtonClick} />
      <GaiaPlusJoin staticText={staticText} onJoinButtonClick={handleJoinButtonClick} />
      <div ref={upgradeSectionRef}>
        <GaiaPlusUpgrade staticText={staticText} />
      </div>
      <GaiaPlusFaq sectionId={faqSectionId} pmSection={pmSection} faqs={faqs} language={language} />
    </div>
  )
}

export default connectRedux((state) => {
  const {
    pmScreen = Map(), pmSection = Map(),
  } = state
  const language = getPrimary(state.user.getIn(['data', 'language'], List()))
  const sectionIds = getPmScreenSectionSectionIds({
    pmScreen, screenType: SCREEN_TYPE_EVENTS_PLUS, language,
  }) || List()

  return {
    auth: state.auth,
    user: state.user,
    plans: state.plans,
    eventsList: state.liveAccessEvents.getIn(['eventsList', language, 'data', 'events']),
    language,
    path: state.resolver.get('path'),
    pmSection,
    sectionIds,
    faqs: selectFaqs(state),
    series: selectSeries(state),
    staticText: state.staticText.getIn(['data', 'gaiaPlusPage', 'data'], Map()),
  }
}, (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setPageSeo: actions.page.setPageSeo,
    getLiveAccessEventList: actions.liveAccessEvents.getLiveAccessEventList,
    setPlanChangeSelected: actions.plans.setPlanChangeSelected,
    renderModal: actions.dialog.renderModal,
  }
})(GaiaPlusPage)
